import React, { useState, useEffect } from 'react';
import PoliceCar from './components/PoliceCar';
import Fireworks from './components/Fireworks';
import AutoExplosions from './components/AutoExplosions';
import SirenOverlay from './components/SirenOverlay';
import Stars from './components/Stars';
import SpeedLines from './components/SpeedLines';
import './App.css';

function App() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="app">
      <SirenOverlay />
      <Stars />
      <SpeedLines />
      <Fireworks />
      <AutoExplosions />

      <div className={`content ${showContent ? 'visible' : ''}`}>
        <h1 className="title">
          <span className="title-letter g">Г</span>
          <span className="title-letter a">А</span>
          <span className="title-letter i">И</span>
          <span className="title-letter space">&nbsp;</span>
          <span className="title-letter p">П</span>
          <span className="title-letter a2">А</span>
          <span className="title-letter r">Р</span>
          <span className="title-letter t">Т</span>
          <span className="title-letter s">С</span>
        </h1>

        <PoliceCar />
      </div>

      <div className="warning-tape top-tape">
        <div className="tape-text">
          &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733;
        </div>
      </div>

      <div className="warning-tape bottom-tape">
        <div className="tape-text reverse">
          &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733; ГАИ ПАРТС &#9733;
        </div>
      </div>
    </div>
  );
}

export default App;
